import { useEffect, useRef, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import swal from "sweetalert";
import formatError from "../../services/FormatError";
import { sortList } from "./Users";
import { modifyDate } from "./Business";
import { getBase64 } from "./Registration";
import { fetchAllContractTypes } from "../../services/ContractTypes";
import { createContract } from "../../services/ContractsService";

const validateContractDetails = (data, base64, recipientMan, signers) => {
  if (
    base64 !== "" &&
    data.name !== "" &&
    data.type !== "" &&
    data.expiryDate !== "" &&
    data.language !== "" &&
    (!recipientMan ||
      (data.recipientName !== "" &&
        data.recipientRole !== "" &&
        data.recipientEmail !== "" &&
        (signers?.length > 0
          ? signers.every((item) => item.name !== "" && item.email !== "")
          : true)))
  ) {
    return true;
  }

  return false;
};

function AddContractPopup({ show, data, onHideModal }) {
  const [contractDetails, setContractDetails] = useState({
    name: "",
    type: "",
    typeOpt: [],
    expiryDate: "",
    language: "",
    recipientName: "",
    recipientRole: "",
    recipientEmail: "",
  });

  const [addTriggered, setAddTriggered] = useState(false);

  const fileInputRef = useRef(null);

  const [base64, setBase64] = useState("");

  const [recipientMan, setRecipientMan] = useState(false);

  const [signers, setAddSigners] = useState([]);

  useEffect(() => {
    getAllContractTypes();
  }, []);

  useEffect(() => {
    if (
      contractDetails.recipientName !== "" ||
      contractDetails.recipientRole !== "" ||
      contractDetails.recipientEmail !== ""
    ) {
      setRecipientMan(true);
    } else {
      setRecipientMan(false);
    }
  }, [
    contractDetails.recipientName,
    contractDetails.recipientRole,
    contractDetails.recipientEmail,
  ]);

  const getAllContractTypes = () => {
    fetchAllContractTypes()
      .then((res) => {
        let response = res.data?.result ?? [];

        response = sortList(response);

        setContractDetails((prevState) => ({
          ...prevState,
          typeOpt: [...response],
        }));
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const updateContractDetails = (key, value) => {
    setContractDetails((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const onChangeFile = async (e) => {
    const file = e.target.files[0];

    const sizeLimit = 505 * 1024 * 1024; // 25 MB

    if (file) {
      const fileType = file.type;

      if (file.size > sizeLimit) {
        swal("Oops", "Max File Size is 25 MB!", "error", {
          button: "Try Again!",
        });

        fileInputRef.current.value = "";

        setBase64("");

        return;
      }

      // Check if the selected file is of type pdf
      if (fileType === "application/pdf") {
        const base64String = await getBase64(file);

        setBase64(base64String);
      } else {
        fileInputRef.current.value = "";

        setBase64("");

        swal("Oops", "Please select a valid PDF file.", "error", {
          button: "Try Again!",
        });
      }
    }
  };

  const onAddSigner = () => {
    setAddSigners((prevState) => [
      ...prevState,
      {
        name: "",
        email: "",
      },
    ]);
  };

  const updateSigners = (itemIndex, key, value) => {
    let previousSigners = [...signers];

    previousSigners = previousSigners.map((item, index) => {
      if (index === itemIndex) {
        return {
          ...item,
          [key]: value,
        };
      }

      return item;
    });

    setAddSigners([...previousSigners]);
  };

  const onDeleteSigner = (index) => {
    const previousSigners = [...signers];

    previousSigners.splice(index, 1);

    setAddSigners([...previousSigners]);
  };

  const onCreateContract = (e) => {
    e.preventDefault();

    if (
      validateContractDetails(contractDetails, base64, recipientMan, signers)
    ) {
      createContract(contractDetails, base64, data, signers)
        .then((res) => {
          setContractDetails({
            name: "",
            type: "",
            typeOpt: [],
            expiryDate: "",
            language: "",
            recipientName: "",
            recipientRole: "",
            recipientEmail: "",
          });

          setAddTriggered(false);

          swal("Success", "Contract created successfully", "success");

          onHideModal();
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    } else {
      setAddTriggered(true);
    }
  };

  return (
    <Modal className="modal fade" show={show} onHide={onHideModal}>
      <div role="document">
        <div>
          <Form>
            <div className="modal-header">
              <h4 className="modal-title fs-20">Create Contract</h4>
              <button type="button" className="close btn" onClick={onHideModal}>
                <span>×</span>
              </button>
            </div>

            <div className="modal-body">
              <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>

              <div className="add-contact-box">
                <div className="add-contact-content">
                  <div
                    className={`form-group ${
                      addTriggered && contractDetails.name === "" ? "" : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <span className="text-danger">*</span>
                      &ensp;
                      <strong>Contract Name</strong>
                    </label>
                    <input
                      type="text"
                      placeholder="Contract Name"
                      className="form-control"
                      value={contractDetails.name}
                      onChange={(e) =>
                        updateContractDetails("name", e.target.value)
                      }
                    />
                  </div>
                  {addTriggered && contractDetails.name === "" && (
                    <div className="text-danger fs-12">
                      Contract Name is Required
                    </div>
                  )}

                  <div
                    className={`form-group ${
                      addTriggered && contractDetails?.type === "" ? "" : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <span className="text-danger">*</span>
                      &ensp;
                      <strong>Contract Type</strong>
                    </label>
                    <select
                      className="form-control"
                      style={{ border: "1px solid #EEEEEE" }}
                      value={contractDetails?.type}
                      onChange={(e) =>
                        updateContractDetails("type", e.target.value)
                      }
                    >
                      <option value="">Select</option>
                      {contractDetails.typeOpt?.length > 0 &&
                        contractDetails.typeOpt.map((item) => (
                          <option
                            key={`contractType${item.id}`}
                            value={item.id}
                          >
                            {item?.name}
                          </option>
                        ))}
                    </select>
                  </div>
                  {addTriggered && contractDetails?.type === "" && (
                    <div className="text-danger fs-12">
                      Contract Type is Required
                    </div>
                  )}

                  <div
                    className={`form-group ${
                      addTriggered && contractDetails?.expiryDate === ""
                        ? ""
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <span className="text-danger">*</span>
                      &ensp;
                      <strong>Expiry Date</strong>
                    </label>
                    <DatePicker
                      className="form-control"
                      dateFormat="YYYY-MM-DD"
                      placeholderText="YYYY-MM-DD"
                      showYearDropdown={true}
                      value={contractDetails?.expiryDate}
                      onChange={(e) =>
                        updateContractDetails("expiryDate", modifyDate(e))
                      }
                    />
                  </div>
                  {addTriggered && contractDetails?.expiryDate === "" && (
                    <div className="text-danger fs-12">
                      Expiry Date is Required
                    </div>
                  )}

                  <div
                    className={`form-group ${
                      addTriggered && base64 === "" ? "" : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <span className="text-danger">*</span>
                      &ensp;
                      <strong>Contract File</strong>
                    </label>
                    <input
                      type="file"
                      accept=".pdf"
                      style={{ height: "100%" }}
                      className="form-control"
                      ref={fileInputRef}
                      onChange={onChangeFile}
                    />
                  </div>
                  {addTriggered && base64 === "" && (
                    <div className="text-danger fs-12">
                      Contract File is Required
                    </div>
                  )}

                  <div
                    className={`form-group ${
                      addTriggered && contractDetails?.language === ""
                        ? ""
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      <span className="text-danger">*</span>
                      &ensp;
                      <strong>Language</strong>
                    </label>
                    <select
                      className="form-control"
                      style={{ border: "1px solid #EEEEEE" }}
                      value={contractDetails?.language}
                      onChange={(e) =>
                        updateContractDetails("language", e.target.value)
                      }
                    >
                      <option value="">Select</option>
                      <option value="English">English</option>
                      <option value="Danish">Danish</option>
                      <option value="Dutch">Dutch</option>
                      <option value="French">French</option>
                      <option value="German">German</option>
                      <option value="Hindi">Hindi</option>
                      <option value="Italian">Italian</option>
                      <option value="Polish">Polish</option>
                      <option value="Portuguese">Portuguese</option>
                      <option value="Russian">Russian</option>
                      <option value="Spanish">Spanish</option>
                      <option value="Swedish">Swedish</option>
                      <option value="Turkish">Turkish</option>
                    </select>
                  </div>
                  {addTriggered && contractDetails?.language === "" && (
                    <div className="text-danger fs-12">
                      Language is Required
                    </div>
                  )}

                  <div
                    className={`form-group ${
                      addTriggered &&
                      recipientMan &&
                      contractDetails?.recipientName === ""
                        ? ""
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      {recipientMan && (
                        <>
                          <span className="text-danger">*</span>
                          &ensp;
                        </>
                      )}
                      <strong>Recipient Name</strong>
                    </label>
                    <input
                      type="text"
                      placeholder="Recipient Name"
                      className="form-control"
                      value={contractDetails.recipientName}
                      onChange={(e) =>
                        updateContractDetails("recipientName", e.target.value)
                      }
                    />
                  </div>
                  {addTriggered &&
                    recipientMan &&
                    contractDetails?.recipientName === "" && (
                      <div className="text-danger fs-12">
                        Recipient Name is Required
                      </div>
                    )}

                  <div
                    className={`form-group ${
                      addTriggered &&
                      recipientMan &&
                      contractDetails?.recipientRole === ""
                        ? ""
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      {recipientMan && (
                        <>
                          <span className="text-danger">*</span>
                          &ensp;
                        </>
                      )}
                      <strong>Recipient Role</strong>
                    </label>
                    <input
                      type="text"
                      placeholder="Recipient Role"
                      className="form-control"
                      value={contractDetails.recipientRole}
                      onChange={(e) =>
                        updateContractDetails("recipientRole", e.target.value)
                      }
                    />
                  </div>
                  {addTriggered &&
                    recipientMan &&
                    contractDetails?.recipientRole === "" && (
                      <div className="text-danger fs-12">
                        Recipient Role is Required
                      </div>
                    )}

                  <div
                    className={`form-group ${
                      addTriggered &&
                      recipientMan &&
                      contractDetails?.recipientEmail === ""
                        ? ""
                        : "mb-3"
                    }`}
                  >
                    <label className="mb-1">
                      {recipientMan && (
                        <>
                          <span className="text-danger">*</span>
                          &ensp;
                        </>
                      )}
                      <strong>Recipient Email</strong>
                    </label>
                    <input
                      type="text"
                      placeholder="Recipient Email"
                      className="form-control"
                      value={contractDetails.recipientEmail}
                      onChange={(e) =>
                        updateContractDetails("recipientEmail", e.target.value)
                      }
                    />
                  </div>
                  {addTriggered &&
                    recipientMan &&
                    contractDetails?.recipientEmail === "" && (
                      <div className="text-danger fs-12">
                        Recipient Email is Required
                      </div>
                    )}

                  {signers?.length > 0 &&
                    signers.map((item, index) => (
                      <div key={`signers${index}`}>
                        <div className="d-flex justify-content-end align-items-center">
                          <span
                            style={{
                              fontSize: "15px",
                              color: "red",
                              padding: "8px",
                              border: "1px solid red",
                              borderRadius: "4px",
                            }}
                            onClick={() => onDeleteSigner(index)}
                          >
                            <i className="fa fa-trash"></i>
                          </span>
                        </div>

                        <div
                          className={`form-group ${
                            addTriggered && item?.name === "" ? "" : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>Signers Name</strong>
                          </label>
                          <input
                            type="text"
                            placeholder="Signers Name"
                            className="form-control"
                            value={item?.name}
                            onChange={(e) =>
                              updateSigners(index, "name", e.target.value)
                            }
                          />
                        </div>
                        {addTriggered && item?.name === "" && (
                          <div className="text-danger fs-12">
                            Signers Name is Required
                          </div>
                        )}

                        <div
                          className={`form-group ${
                            addTriggered && item?.email === "" ? "" : "mb-3"
                          }`}
                        >
                          <label className="mb-1">
                            <span className="text-danger">*</span>
                            &ensp;
                            <strong>Signers Email</strong>
                          </label>
                          <input
                            type="text"
                            placeholder="Signers Email"
                            className="form-control"
                            value={item?.email}
                            onChange={(e) =>
                              updateSigners(index, "email", e.target.value)
                            }
                          />
                        </div>
                        {addTriggered && item?.email === "" && (
                          <div className="text-danger fs-12">
                            Signers Email is Required
                          </div>
                        )}
                      </div>
                    ))}

                  <div className="form-group">
                    <div className="d-flex justify-content-end align-items-center">
                      <button
                        type="button"
                        className="btn btn-outline-success"
                        onClick={onAddSigner}
                      >
                        Add Signer
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn"
                style={{ background: "#808080", color: "#fff" }}
                onClick={onHideModal}
              >
                Discard
              </button>
              <button
                type="submit"
                className="btn btn-success"
                onClick={onCreateContract}
              >
                Create Contract
              </button>
            </div>
          </Form>
        </div>
      </div>
    </Modal>
  );
}

export default AddContractPopup;
